import { Button, Flex, Select } from '@chakra-ui/react'
import Sidebar from '../../components/Sidebar'
import SimpleNav from '../../components/SimpleNav'
import Tabs, { Tab } from '../../components/Tabs'
import Agency from './Agency'
import FiltersAgency from './Agency/FiltersAgency'
import Driver from './Driver'
import FiltersDriver from './Driver/FiltersDriver'
import useControl from './useControl'
import useInitial from './useInitial'

export default function TouristGroups() {
    useInitial()
    const { tabProps, openModal, getTextButton } = useControl()

    return (
        <Sidebar>
            <SimpleNav title="Grupos turísticos" />
            <Tabs {...tabProps}>
                <Tab value="agency">Agencias</Tab>
                <Tab value="driver">Guías locales</Tab>
            </Tabs>
            <Flex
                justifyContent="space-between"
                display={{ base: 'flex', md: 'none' }}
            >
                <Select
                    w="200px"
                    value={tabProps.value}
                    onChange={e => tabProps.onTab(e.target.value)}
                >
                    <option value="agency">Agencias</option>

                    <option value="driver">Guías locales</option>
                </Select>
                <Button variant="alo-blue:md-xl" onClick={openModal}>
                    + Nuevo
                </Button>
            </Flex>
            <Flex
                mt={4}
                mb={4}
                w={{
                    xl: 'auto',
                    lg: tabProps.value === 'item' ? 'full' : 'auto'
                }}
                justifyContent={{
                    md:
                        tabProps.value === 'category'
                            ? 'flex-end'
                            : 'space-between',
                    base: 'flex-end'
                }}
            >
                {tabProps.value === 'driver' && <FiltersDriver />}
                {tabProps.value === 'agency' && <FiltersAgency />}
                <Button
                    variant="alo-blue:md-xl"
                    onClick={openModal}
                    display={{ base: 'none', md: 'inline' }}
                    ml="2"
                >
                    {getTextButton()}
                </Button>
            </Flex>
            {tabProps.value === 'driver' && <Driver />}
            {tabProps.value === 'agency' && <Agency />}
        </Sidebar>
    )
}
